import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {




  log(...args: any) {
    // console.log(args);

  }
}



